'use client'

import { ImageHelper } from '@/lib/helpers/image.helper'
import { sanitize } from '@/lib/helpers/sanitize'
import { Quote } from 'lucide-react'
import Image from 'next/image'
import { useProductDetailSafe } from '../context/product-detail-context'

/**
 * Card "Why we make it?" tĩnh cho layout QR mobile — không dùng Accordion vì
 * chỉ có một mục cố định, luôn mở, nội dung lấy từ product.short_desc thay vì
 * CMS extra_technical_specifications. Có id để ProductGalleryQr scrollIntoView
 * tới khi bấm vào title trong gallery overlay.
 */
export const WhyWeMakeItQr = () => {
  const { product } = useProductDetailSafe()

  if (!product.short_desc) return null

  return (
    <div id='why-we-make-it' className='bg-neutral-100 px-5 pt-4'>
      <div className='relative overflow-hidden rounded-3xl bg-gradient-to-br from-primary-600 via-primary to-primary-400 p-5 text-white shadow-[0_16px_36px_rgba(39,59,205,0.35)]'>
        <div className='pointer-events-none absolute -bottom-12 -left-8 h-28 w-28 rounded-full bg-white/10' />
        <span className='pointer-events-none absolute -right-6 -top-6 flex h-32 w-32 items-center justify-center opacity-25 blur-[1px]'>
          <Image
            src={ImageHelper.getImageUrl(
              '/image/2026/07/30/white_-_symbol.png',
              '',
              256
            )}
            alt=''
            width={128}
            height={128}
            className='h-full w-full object-contain'
            unoptimized
          />
        </span>

        <div className='relative flex items-center gap-3'>
          <span className='flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-white/20'>
            <Quote className='h-4 w-4 fill-white text-white' />
          </span>
          <h3 className='font-sans text-lg font-bold leading-tight'>
            Why we make it?
          </h3>
        </div>
        <div
          className={`relative mt-3 text-sm leading-relaxed text-white/90 [&>*:first-child]:before:mr-0.5 [&>*:first-child]:before:font-serif [&>*:first-child]:before:text-lg [&>*:first-child]:before:text-white/50 [&>*:first-child]:before:content-['"'] [&>*:last-child]:after:ml-0.5 [&>*:last-child]:after:font-serif [&>*:last-child]:after:text-lg [&>*:last-child]:after:text-white/50 [&>*:last-child]:after:content-['"']`}
          dangerouslySetInnerHTML={{ __html: sanitize(product.short_desc) }}
        />
      </div>
    </div>
  )
}
